import React from "react";
import { ItemProps } from "./types";
import s from "./style.module.scss";
import { Link } from "react-router-dom";
import { useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";

const Item: React.FC<ItemProps> = ({ icon, label, href, callback }) => {
  const { user_info } = useAppSelector(userSelect);

  return (
    <li className={s.item}>
      {href && <Link to={href} />}
      {callback && user_info && (
        <button onClick={() => callback(user_info.msisdn)}></button>
      )}

      <div className={s.icon}>{icon}</div>

      <span className={s.label}>{label}</span>
    </li>
  );
};

export default Item;
